import React from 'react'

function NotFoundPage() {
  return (  
       <>
      {/* HERO AREA STARTS */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg11.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>404 Error</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> <span>404 Error</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* HERO AREA ENDS */}

      {/* OTHERS AREA STARTS */}
      <div className="error-section-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="images-conten-area">
                <div className="img1 image-anime reveal">
                  <img src="assets/img/all-images/others/error.png" alt="" />
                </div>
                <div className="space40"></div>
                <div className="heading2 text-center">
                  <h2>Oops!! Page Not Found</h2>
                  <div className="space24"></div>
                  <p>
                    While you're here, why not check out some of our top-notch web hosting{' '}
                    <br className="d-lg-block d-none" /> services? Whether you're just starting a new website or looking to upgrade{' '}
                    <br className="d-lg-block d-none" /> your current hosting,
                    we offer solutions tailored to your needs.
                  </p>
                  <div className="space32"></div>
                  <div className="btn-area1">
                    <a href="/" className="vl-btn2">
                      Back To Home Page <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* OTHERS AREA ENDS */}
    </>
  )
}

export default NotFoundPage
